"use strict";

var _angular = require("angular");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = require("debug")("compliance:rp-select");

_angular2.default.module("fleetviewApp").directive("routingProfileSelect", routingProfileSelect);

var vehicleTypeMap = {
  "Truck": "Heavy Duty",
  "MidsizeTruck": "Medium Duty",
  "LightDuty": "Light Duty",
  "9": "School Bus"
};

function routingProfileSelect() {

  // logic for which profiles to show in drop-down...
  function getItemsForSelect(scope) {
    var route = scope.route;

    debug("route:", route);
    if (route.routingProfileFromPrescribedRoute) {
      debug("route.routingProfileFromPrescribedRoute");
      route.routingProfiles.unshift(route.routingProfileFromPrescribedRoute); // aka 'Trip Options'
      route.selectedRoutingProfile = route.routingProfiles[0];
    }

    // if any RPs are companyProfile, select it
    var companyProfile = route.routingProfiles.find(function (rp) {
      return rp.source === "CompanyProfile";
    });
    if (companyProfile) {
      route.selectedRoutingProfile = companyProfile;
    }

    var items = route.routingProfiles.map(function (rp) {
      if (!rp.name) {
        // use vehicleType as a backup name
        if (vehicleTypeMap[rp.vehicleType]) {
          rp.name = vehicleTypeMap[rp.vehicleType];
        } else {
          rp.name = rp.vehicleType;
        }
      }
      return rp;
    });

    // filter out Account-RPs when we have VehicleGroup-RPs
    var companyVehicleGroupRP = items.find(function (r) {
      return r.source === "CompanyProfile_VG";
    });
    if (companyVehicleGroupRP) {
      items = items.filter(function (r) {
        return r.source !== "CompanyProfile_Acct";
      });
    }

    // sets selectedRP when its needed
    if (companyVehicleGroupRP && !route.selectedRoutingProfile) {
      route.selectedRoutingProfile = companyVehicleGroupRP;
    }

    // if !rpId & !TripOptions & !selectedRP, add the 'Unknown profile'
    if (!route.routingProfileId && !route.routingProfileFromPrescribedRoute && !route.selectedRoutingProfile) {
      items.unshift({ name: "Unknown profile", source: "Default", vehicleType: "Truck" });
      route.unknownProfile = true;
      debug("no routingProfileId");
    }

    debug("items:", items);
    return items;
  }

  function sourceName() {
    var selectedRP = this.route.selectedRoutingProfile || {};
    if (selectedRP.source) {
      if (selectedRP.source.includes("Driver")) {
        return "Driver"; // used to display to end-user
      } else if (selectedRP.source.includes("Company")) {
        return "Company";
      }
      return selectedRP.source;
    }
  }

  function vehicleTypeName() {
    var selectedRP = this.route.selectedRoutingProfile || {};
    var vType = selectedRP.vehicleType;

    if (vehicleTypeMap[vType]) {
      return vehicleTypeMap[vType];
    }
    return vType;
  }

  function showLabel() {
    if (this.route.dropDownItems.length === 1) {
      return true;
    }
    var selectedRP = this.route.selectedRoutingProfile || {};
    // if source if company profile or trip options, show label
    return selectedRP.source === "CompanyProfile" || selectedRP.source === "DriverProfile";
  }

  function showLabelWarning() {
    var _route = this.route,
        unknownProfile = _route.unknownProfile,
        dropDownItems = _route.dropDownItems;

    var item = dropDownItems[0];
    if (item && item.source === "DriverProfile") {
      return true;
    }
    if (dropDownItems.length === 0 || unknownProfile) {
      return true;
    }
    return false;
  }

  function showDropDownWarning() {
    var selectedRP = this.route.selectedRoutingProfile;
    if (!selectedRP) {
      return true;
    }
    if (selectedRP.source === "DriverProfile") {
      return true;
    }
    if (selectedRP.source.includes("Company")) {
      return false;
    }
    if (this.route.unknownProfile) {
      return true;
    }

    return false;
  }

  function showDropDown() {
    // debug("$crtl", this.$ctrl)
    var route = this.route;
    if (!route || !route.routingProfiles) {
      return false;
    }

    var selectedRP = route.selectedRoutingProfile;
    if (selectedRP && selectedRP.source === "CompanyProfile") {
      return false;
    } else if (selectedRP && selectedRP.source === "DriverProfile") {
      // tripOptions from CP v10
      return false;
    }

    return route.dropDownItems.length > 1;
  }

  var directive = {
    template: require("./routingprofile-select.directive.html"),
    restrict: "E",
    scope: false, // use parent scope
    link: function link(scope, element, attrs) {
      if (!scope.route) {
        scope.route = scope.$ctrl.route; // ensure scope.route exists, route-detail only has {route} on $ctrl
      }
      scope.showDropDown = showDropDown;
      scope.showLabel = showLabel;
      scope.showLabelWarning = showLabelWarning;
      scope.showDropDownWarning = showDropDownWarning;
      scope.vehicleTypeName = vehicleTypeName;
      scope.sourceName = sourceName;
      var items = getItemsForSelect(scope);
      scope.route.routingProfiles = items;
      scope.route.dropDownItems = items;

      // logic for setting selectedRoutingProfile
      if (scope.route.unknownProfile) {
        scope.route.selectedRoutingProfile = items[0];
      }
      debug("rp-select-> scope", scope);
    }
  };
  return directive;
}


// WEBPACK FOOTER //
// ./app/compliance/routingprofile-select.directive.js